import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionLabel } from "./SectionLabel";

export const CTASection = ({
  label = "Get in touch",
  title = "Facing a Commercial, Market or Industrial Challenge?",
  body = "If you are evaluating a new market, growth opportunity, distribution model, industrial project or technical-commercial question, MATRIVON can provide an independent perspective.",
  primary = { to: "/contact", label: "Discuss Your Business Challenge" },
  secondary = { to: "/advisory", label: "Explore Advisory" },
}) => (
  <section className="relative overflow-hidden bg-brand-ink text-white">
    <div className="absolute inset-0 grid-paper-dark opacity-40" />
    <div className="relative mx-auto max-w-5xl px-5 py-24 text-center lg:px-8">
      <SectionLabel light className="justify-center">{label}</SectionLabel>
      <h2 className="mx-auto max-w-3xl font-heading text-3xl font-bold tracking-tight lg:text-4xl">
        {title}
      </h2>
      <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/70">{body}</p>
      <div className="mt-9 flex flex-wrap justify-center gap-4">
        <Link
          to={primary.to}
          data-testid="cta-primary"
          className="inline-flex items-center gap-2 bg-brand-red px-7 py-3.5 text-sm font-semibold text-white transition-all hover:-translate-y-px hover:brightness-110"
        >
          {primary.label} <ArrowRight className="h-4 w-4" />
        </Link>
        {secondary && (
          <Link
            to={secondary.to}
            data-testid="cta-secondary"
            className="inline-flex items-center gap-2 border border-white/25 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10"
          >
            {secondary.label}
          </Link>
        )}
      </div>
    </div>
  </section>
);
